import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { Bars } from "react-loader-spinner";
import { EditProduct } from "../EditProduct";
import { useNavigate, useParams } from "react-router-dom";
import store from "../../../store/store";
import { fetchProductById, reset } from "../reducer/productDetailsSlice";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { brandsAsyncThunk, categoryAsyncThunk, tagsAsyncThunk } from "../../Products/reducer/productSlice";

const InitMiddlewareProductEdit:React.FC<any> = (props) => {
  const { userToken } = useSelector((state: any) => state.rootReducer?.auth);
  const { productDetails, isLoading, isSuccess, editProductRes } = useSelector(
    (state: any) => state.rootReducer?.productDetail
  );

  const navigate = useNavigate();

  let { productId } = useParams();

  console.log('productIdsss', productId)

  useEffect(() => {
    if (productId) {
      store.dispatch(fetchProductById(productId));
    }

    return () => {
      store.dispatch(reset())
    }
  }, [productId]);

  useEffect(() => {
    const data: any = [
      {
        label: "Products",
        link: `/products`,
      },
      {
        label: "Edit",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
    store.dispatch(categoryAsyncThunk())
    store.dispatch(brandsAsyncThunk())
    store.dispatch(tagsAsyncThunk())
  }, [productId]);

  if (isLoading.productDetails) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <Bars
          height="80"
          width="80"
          color="#2460a2"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }
  console.log('editProductRes', editProductRes)

  if (isSuccess && editProductRes?.data?.success === true) {
    navigate("/products");
    return null;
  } else {
    return <EditProduct {...props} />;
  }
};

export default InitMiddlewareProductEdit;
